import React from 'react';
import PropTypes from 'prop-types';
import { length } from 'v1/helpers/measurements';
import MeasurementInput from '../MeasurementInput/MeasurementInput';
import './Dimension2DInput.scss';

/**
 * A dimension 2D input allows the user to input X and Y measurements.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const Dimension2DInput = ({
  value,
  disabled,
  field,
  units,
  appearance,
  size,
  className,
  removeAutocomplete,
  onBlur,
  onChange
}) => {
  // Each measurement input expects an object value containing fields: amount and unit.
  // Before we render, we must parse the dimension JSON string into the two measurements.
  const values = JSON.parse(value || '{}');
  const xValue = values.x || {};
  const yValue = values.y || {};

  // handleChange will convert the dimension value objects back into a JSON string for storage
  const handleChange = (fieldName, value) => {
    onChange(
      fieldName,
      JSON.stringify({
        x: xValue,
        y: yValue,
        [fieldName]: value
      })
    );
  };

  return (
    <div className={className}>
      <MeasurementInput
        disabled={disabled}
        field={field}
        value={xValue}
        onBlur={onBlur}
        units={units}
        onChange={value => handleChange('x', value)}
        appearance={appearance}
        size={size}
        removeAutocomplete={removeAutocomplete}
      />
      <span className="Dimension2DInput-separator">by</span>
      <MeasurementInput
        disabled={disabled}
        field={field}
        value={yValue}
        onBlur={onBlur}
        units={units}
        onChange={value => handleChange('y', value)}
        appearance={appearance}
        size={size}
        removeAutocomplete={removeAutocomplete}
      />
    </div>
  );
};

Dimension2DInput.defaultProps = {
  units: [...length]
};

Dimension2DInput.propTypes = {
  className: PropTypes.string,
  field: PropTypes.string,
  label: PropTypes.string,
  value: PropTypes.string,
  appearance: PropTypes.string,
  size: PropTypes.string,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  disabled: PropTypes.bool,
  units: PropTypes.array,
  removeAutocomplete: PropTypes.bool
};

export default Dimension2DInput;
